"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreDocumentUploadFormToJSON = exports.PreDocumentUploadFormFromJSONTyped = exports.PreDocumentUploadFormFromJSON = void 0;
const runtime_1 = require("../runtime");
function PreDocumentUploadFormFromJSON(json) {
    return PreDocumentUploadFormFromJSONTyped(json, false);
}
exports.PreDocumentUploadFormFromJSON = PreDocumentUploadFormFromJSON;
function PreDocumentUploadFormFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'documentFile': json['documentFile'],
        'fileName': json['fileName'],
        'nameLinking': json['nameLinking'],
        'documentType': !runtime_1.exists(json, 'documentType') ? undefined : json['documentType'],
        'alienRegistrationNumber': !runtime_1.exists(json, 'alienRegistrationNumber') ? undefined : json['alienRegistrationNumber'],
        'passportNumber': !runtime_1.exists(json, 'passportNumber') ? undefined : json['passportNumber'],
        'passportExpiration': !runtime_1.exists(json, 'passportExpiration') ? undefined : json['passportExpiration'],
        'licenseIssuingState': !runtime_1.exists(json, 'licenseIssuingState') ? undefined : json['licenseIssuingState'],
        'licenseNumber': !runtime_1.exists(json, 'licenseNumber') ? undefined : json['licenseNumber'],
        'licenseIssueDate': !runtime_1.exists(json, 'licenseIssueDate') ? undefined : json['licenseIssueDate'],
        'licenseExpirationDate': !runtime_1.exists(json, 'licenseExpirationDate') ? undefined : json['licenseExpirationDate'],
    };
}
exports.PreDocumentUploadFormFromJSONTyped = PreDocumentUploadFormFromJSONTyped;
function PreDocumentUploadFormToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'documentFile': value.documentFile,
        'fileName': value.fileName,
        'nameLinking': value.nameLinking,
        'documentType': value.documentType,
        'alienRegistrationNumber': value.alienRegistrationNumber,
        'passportNumber': value.passportNumber,
        'passportExpiration': value.passportExpiration,
        'licenseIssuingState': value.licenseIssuingState,
        'licenseNumber': value.licenseNumber,
        'licenseIssueDate': value.licenseIssueDate,
        'licenseExpirationDate': value.licenseExpirationDate,
    };
}
exports.PreDocumentUploadFormToJSON = PreDocumentUploadFormToJSON;
//# sourceMappingURL=PreDocumentUploadForm.js.map